export const DROPDOWN_INIT = 'DROPDOWN_INIT';
export const DROPDOWN_TOGGLE = 'DROPDOWN_TOGGLE';
export const DROPDOWN_CLOSE = 'DROPDOWN_CLOSE';
export const DROPDOWN_SELECT = 'DROPDOWN_SELECT';

/**
 * TODO Decide, how tables: results, entries and catalogues should be updated
 * We were passing afterAction as a parameter THEN
 * afterAction && actions.push(afterAction);
 */
export function defaults(stateKey, defaultValue) {
    const actions = [
        {
            type: DROPDOWN_INIT,
            defaultValue,
            stateKey
        }
    ];

    return actions;
}

export function toggle(stateKey) {
    return {
        type: DROPDOWN_TOGGLE,
        stateKey
    };
}

export function close(stateKey) {
    return {
        type: DROPDOWN_CLOSE,
        stateKey
    };
}

export function select(stateKey, value, afterAction) {
    const actions = [
        {
            type: DROPDOWN_SELECT,
            value,
            stateKey
        }
    ];

    afterAction && actions.push(afterAction);

    return actions;
}



// WEBPACK FOOTER //
// ./src/js/modules/Dropdown/actions/index.js